import { RadioGroupField } from '@monorepo/shared/componentsV2/fields/RadioGroupField';
import { SelectableOption } from '@monorepo/shared/types/SelectableOption';
import { isRequired as isRequiredValidator } from '@monorepo/shared/utils/validators';
import { JoinType } from 'mapistry-shared';
import React from 'react';
import styled from 'styled-components';
import { StyledDescription, StyledH3 } from './styled';

const joinTypeOptions: SelectableOption[] = [
  {
    supertitle: 'Inner Join',
    label: 'Only include matching rows',
    value: JoinType.INNER,
  },
  {
    supertitle: 'Full Outer Join',
    label: 'Include all rows',
    value: JoinType.FULL_OUTER,
  },
  {
    supertitle: 'Left Outer Join',
    label:
      'Include all rows in data source 1, but only matching rows from data source 2',
    value: JoinType.LEFT_OUTER,
  },
];

const StyledLink = styled.a`
  color: ${({ theme }) => theme.colors.lightBlue};
  text-decoration: none;

  &:hover {
    color: ${({ theme }) => theme.colors.darkerBlue};
  }

  &:focus,
  &:focus-visible {
    color: ${({ theme }) => theme.colors.lightBlue};
  }
`;

export function JoinTypeModalPage() {
  return (
    <>
      <StyledH3>Choose connection type</StyledH3>
      <StyledDescription>
        {`Choose how you'd like to connect the rows from your combined data sources. `}
        <StyledLink
          href="edpJoinTypesProductGuideUrl"
          target="_blank"
          rel="noreferrer"
        >
          Not sure?
        </StyledLink>
      </StyledDescription>
      <RadioGroupField
        isLabelHidden
        label="Join Rows"
        name="joinType"
        options={joinTypeOptions}
        required
        validate={isRequiredValidator}
        variant="outlined"
      />
    </>
  );
}
